export * from '@discoverer/fuse/services/tailwind/tailwind.module';
export * from '@discoverer/fuse/services/tailwind/tailwind.service';
